import { useState, useEffect } from "react";
import { FormGroup, Input } from "reactstrap";

const initialExternalLink = {
  title: "",
  url: "",
};

const ExternalLinkEditor = ({ onChange, resetData, setResetData }) => {
  const [externalLink, setExternalLink] = useState(initialExternalLink);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newItem = { ...externalLink, [name]: value };
    setExternalLink(newItem);

    onChange({
      Type: "External",
      Title: newItem.title,
      Link: newItem.url,
    });
  };

  useEffect(() => {
    if (resetData === true) {
      setExternalLink(initialExternalLink);
      setResetData(false);
    }
  }, [resetData, setResetData]);

  return (
    <>
      <FormGroup>
        <h5>Name</h5>
        <Input
          placeholder="Name"
          name="title"
          type="text"
          value={externalLink.title}
          onChange={handleChange}
          bsSize="sm"
        />
      </FormGroup>
      <FormGroup>
        <h5>URL</h5>
        <Input
          placeholder="https://growthcloud.com"
          name="url"
          type="text"
          value={externalLink.url}
          onChange={handleChange}
          bsSize="sm"
        />
      </FormGroup>
    </>
  );
};

export default ExternalLinkEditor;
